import type { CSSProperties } from 'react';

export const HiveLogo = ({
  width = 24,
  height = 24,
  className,
  style,
}: {
  width?: number;
  height?: number;
  className?: string;
  style?: CSSProperties;
}) => {
  return (
    <img
      src="/imgs/logo.svg"
      alt="Hive Logo"
      width={width}
      height={height}
      className={className}
      style={style}
    />
  );
};
